import React from 'react';
import WeeklySummaryForm from '../components/daily-planner/WeeklySummaryForm';

const WeeklySummaryPage = () => {
  return <WeeklySummaryForm />;
};

export default WeeklySummaryPage;
